<div class="container px-0">
    <div class="row">
        <div
            class="col-12 mb-2"
            [class.col-md-6]="!stacked"
            [class.mb-md-0]="!stacked"
        >
            <button
                class="btn btn-primary w-100 register-btn"
                [routerLink]="[
                    '/',
                    communityCode,
                    this.languageService.currentLanguageCode,
                    'register',
                ]"
            >
                <span
                    [innerHtml]="'register-button-text' | cmsText | async"
                ></span>
                <i class="fa fa-chevron-right ms-2"></i>
            </button>
        </div>
        <div class="col-12 mb-3 mb-md-0" [class.col-md-6]="!stacked">
            <button
                *ngIf="$readMoreBtnUrl | async as url"
                class="btn btn-primary register-btn already-register-btn"
                [class.btn-muted]="!grey"
                [class.btn-muted-grey]="grey"
                [class.w-100]="stacked"
                [routerLink]="url"
            >
                <span
                    [innerHtml]="
                        'already-register-button-text' | cmsText | async
                    "
                ></span>
            </button>
        </div>
    </div>
</div>
